export const REPORT_TEXT_TEMPLATE_KEYS = [
  'assignmentDescription',
  'summaryAndRecommendations',
  'workRegisterResultWhenClear',
  'workRegisterResultWhenDeviations',
  'workRegisterActionsWhenClear',
  'workRegisterActionsWhenDeviations',
  'identificationResultWhenClear',
  'identificationResultWhenDeviations',
  'identificationActionsWhenClear',
  'identificationActionsWhenDeviations',
  'id06DeviationsResultWhenClear',
  'id06DeviationsResultWhenDeviations',
  'id06DeviationsActionsWhenClear',
  'id06DeviationsActionsWhenDeviations',
  'safetyEquipmentResultWhenClear',
  'safetyEquipmentResultWhenDeviations',
  'safetyEquipmentActionsWhenClear',
  'safetyEquipmentActionsWhenDeviations',
  'workPermitResultWhenClear',
  'workPermitResultWhenDeviations',
  'workPermitActionsWhenClear',
  'workPermitActionsWhenDeviations',
  'secondmentRegulationsResultWhenClear',
  'secondmentRegulationsResultWhenDeviations',
  'secondmentRegulationsActionsWhenClear',
  'secondmentRegulationsActionsWhenDeviations',
] as const;

export type ReportTextTemplateKey = (typeof REPORT_TEXT_TEMPLATE_KEYS)[number];

export type TemplateVariant = 'WhenClear' | 'WhenDeviations';

export type TopicFieldKind = 'Result' | 'Actions';

export type PersondataTopicId =
  | 'workRegister'
  | 'identification'
  | 'id06Deviations'
  | 'safetyEquipment'
  | 'workPermit'
  | 'secondmentRegulations';

export type PersondataTopicConfig = {
  id: PersondataTopicId;
  title: string;
  placeholders: string[];
  result: {
    WhenClear: ReportTextTemplateKey;
    WhenDeviations: ReportTextTemplateKey;
  };
  actions: {
    WhenClear: ReportTextTemplateKey;
    WhenDeviations: ReportTextTemplateKey;
  };
};

const SHARED_METADATA_PLACEHOLDERS = [
  '{{date}}',
  '{{completedAt}}',
  '{{projectName}}',
  '{{address}}',
  '{{city}}',
  '{{clientName}}',
  '{{mainContractor}}',
  '{{numberOfPersonnel}}',
  '{{numberOfControlledPersonnel}}',
];

export const PERSONDATA_TOPICS: PersondataTopicConfig[] = [
  {
    id: 'workRegister',
    title: 'Elektronisk personalliggare (EPL)',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfNotControlledPersonnel}}',
      '{{percentageOfNotControlledPersonnel}}',
      '{{numberOfAdditionalPersonnel}}',
      '{{percentageOfAdditionalPersonnel}}',
      '{{numberOfCheckedInAndControlledPersonnel}}',
      '{{percentageOfCheckedInAndControlledPersonnel}}',
    ],
    result: {
      WhenClear: 'workRegisterResultWhenClear',
      WhenDeviations: 'workRegisterResultWhenDeviations',
    },
    actions: {
      WhenClear: 'workRegisterActionsWhenClear',
      WhenDeviations: 'workRegisterActionsWhenDeviations',
    },
  },
  {
    id: 'identification',
    title: 'Giltig legitimation',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfPersonnelWithInvalidIdentification}}',
      '{{percentageOfPersonnelWithInvalidIdentification}}',
    ],
    result: {
      WhenClear: 'identificationResultWhenClear',
      WhenDeviations: 'identificationResultWhenDeviations',
    },
    actions: {
      WhenClear: 'identificationActionsWhenClear',
      WhenDeviations: 'identificationActionsWhenDeviations',
    },
  },
  {
    id: 'id06Deviations',
    title: 'ID06',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfPersonnelWithIdCardDeviations}}',
      '{{percentageOfPersonnelWithIdCardDeviations}}',
    ],
    result: {
      WhenClear: 'id06DeviationsResultWhenClear',
      WhenDeviations: 'id06DeviationsResultWhenDeviations',
    },
    actions: {
      WhenClear: 'id06DeviationsActionsWhenClear',
      WhenDeviations: 'id06DeviationsActionsWhenDeviations',
    },
  },
  {
    id: 'safetyEquipment',
    title: 'Skyddsutrustning',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfPersonnelWithoutSafetyEquipment}}',
      '{{percentageOfPersonnelWithoutSafetyEquipment}}',
    ],
    result: {
      WhenClear: 'safetyEquipmentResultWhenClear',
      WhenDeviations: 'safetyEquipmentResultWhenDeviations',
    },
    actions: {
      WhenClear: 'safetyEquipmentActionsWhenClear',
      WhenDeviations: 'safetyEquipmentActionsWhenDeviations',
    },
  },
  {
    id: 'workPermit',
    title: 'Arbetstillstånd',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfPersonnelWithoutWorkPermit}}',
      '{{percentageOfPersonnelWithoutWorkPermit}}',
    ],
    result: {
      WhenClear: 'workPermitResultWhenClear',
      WhenDeviations: 'workPermitResultWhenDeviations',
    },
    actions: {
      WhenClear: 'workPermitActionsWhenClear',
      WhenDeviations: 'workPermitActionsWhenDeviations',
    },
  },
  {
    id: 'secondmentRegulations',
    title: 'Utstationering / A1',
    placeholders: [
      ...SHARED_METADATA_PLACEHOLDERS,
      '{{numberOfPersonnelWithoutCertificate}}',
      '{{percentageOfPersonnelWithoutCertificate}}',
    ],
    result: {
      WhenClear: 'secondmentRegulationsResultWhenClear',
      WhenDeviations: 'secondmentRegulationsResultWhenDeviations',
    },
    actions: {
      WhenClear: 'secondmentRegulationsActionsWhenClear',
      WhenDeviations: 'secondmentRegulationsActionsWhenDeviations',
    },
  },
];
